var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validations)?_c('div',_vm._l((_vm.validations),function(validation,index){return (validation.condition)?_c('span',{key:index,staticClass:"block cl-error h6 mt8",attrs:{"data-testid":"errorMessage"}},[_vm._v(" "+_vm._s(validation.text)+" ")]):_vm._e()}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }